// *************************************
//
//   This is the main entry point of unsub_ui client
//
// *************************************
import './setupLocale'; // Must be the first

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './App';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
